export const AVAILABLE_PERCENTILES_OPTIONS = [
  { value: 99, label: 'P99' },
  { value: 95, label: 'P95' },
  { value: 90, label: 'P90' },
  { value: 75, label: 'P75' },
  { value: 50, label: 'P50' },
] as const;
